import { render } from "./wButton.vue?vue&type=template&id=4f5eaa7e&ts=true"
import script from "./wButton.vue?vue&type=script&lang=ts"
export * from "./wButton.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__